import $ from "jquery";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import SiteController from "./site/site-controller.js";

import SiteButton from "./site/site-button.js";
import SiteAni from "./site/site-animations.js";

import "./content/carousel";
import "./site/site-header";
import "./content/social-share";
import "./content/youtube-video-embed";
import "./content/load-more-blogs";
import "./content/a11y-dialog";
import "./content/products-filters";
import "./content/search";
import "./content/distributor-country-dorpdown";

import "./content/age-gate.js";
import "../../blocks/content/d13-card-history-entry/d13-card-history-entry.js";
import "../../blocks/masthead/c1-masthead-homepage/c1-masthead-homepage.js";
import "../../blocks/content/e3-dropdown-distributor-country/e3-dropdown-distributor-country.js";
import "../../template-parts/foliage/index.js";
import "./render.js";

gsap.registerPlugin(ScrollTrigger);

const modules = {
  "site-button": SiteButton,
  "site-ani": SiteAni,
};

setTimeout(() => {
  const siteController = new SiteController(modules);
  siteController.init();
  window.dispatchEvent(new CustomEvent("site-ani-find"));
}, 500);
